// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'
import jwtConfig from './jwtConfig'
import axios from 'axios'


const { jwt } = useJwt(jwtConfig)

jwt.login = async (...args) => {
  const qs = require("qs")
  const b_args = { ...qs.parse(args[0]), client_id: 1 }
  b_args.username = b_args.email || ''
  const b_login = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/login`, qs.stringify(b_args))
  const b_res = b_login.data
  await axios.get(`${process.env.REACT_APP_ADMIN_URL}/session/me`, {
    headers: {
      Authorization: `Bearer ${b_res.access_token}`
    }
  })
  const suscription = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/suscription/me`, {
    headers: {
      Authorization: `Bearer ${b_res.access_token}`
    }
  })
  const b_res_unified = { ...suscription.data, ...b_res, suscription: suscription.data }
  localStorage.setItem("troiatec", JSON.stringify(b_res_unified))
  
  // Retornar directamente la respuesta de Babel para que Login.js la procese, en vez de hacer login en Analyzer
  return Promise.resolve({ data: b_res_unified })
}

export default jwt
